import AdminSavedSearchesReducer from './AdminSavedSearchesReducer';

export default from './AdminSavedSearchesContainer';
export const AdminSavedSearchesReducers = {
  AdminSavedSearchesReducer,
};
